import React, { memo } from 'react';

export const DoorGlazedSmall: React.FC = memo(() => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.0166 4H18.5166C18.7927 4 19.0166 4.22386 19.0166 4.5V20.5C19.0166 20.7761 18.7927 21 18.5166 21H17.0166"
      stroke="#919395"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M5 4.21469C5 3.97265 5.17336 3.76537 5.41159 3.72257L14.4116 2.10571C14.7182 2.05062 15 2.2863 15 2.59783V22.422C15 22.7268 14.7296 22.9606 14.428 22.9167L5.42799 21.6069C5.18225 21.5711 5 21.3604 5 21.1121V4.21469Z"
      fill="#C2E5F4"
      stroke="#21282B"
      strokeWidth="1.25"
    />
    <path d="M13.0166 12L13.0166 12.8708" stroke="#21282B" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M5 4.21469C5 3.97265 5.17336 3.76537 5.41159 3.72257L14.4116 2.10571C14.7182 2.05062 15 2.2863 15 2.59783V22.422C15 22.7268 14.7296 22.9606 14.428 22.9167L5.42799 21.6069C5.18225 21.5711 5 21.3604 5 21.1121V4.21469Z"
      stroke="#21282B"
      strokeWidth="1.25"
    />
    <path d="M7.38916 5.49805L6.86064 6.02622" stroke="#21282B" strokeLinecap="round" />
    <path d="M9.03369 6.21777L7.38904 7.86134" stroke="#21282B" strokeLinecap="round" />
  </svg>
));
